import { useContext, useEffect, useState } from "react";
import { MaintenanceServices } from
    "lib/services/api/operaitons/WorkShop/TaskLibrary/Maintenance/maintenance_operation";
import { ToastMessageContext } from "lib/contexts/message_context";
import { getOrganisationId } from "lib/utils/common_utils";

/**
 * Fetch customer list
 *
 * @param {Boolean} customerStatus - flag to trigger API
 */
const useGetCustomerDetails = (customerStatus) => {
    const message = useContext(ToastMessageContext);

    const [customerDetails, setCustomerDetails] = useState([]);

    const getCustomerDetails = async () => {
        try {
            const params = {
                organisation_id: getOrganisationId(),
            };

            const res = await MaintenanceServices.getCustomerList(params);

            if (res) {
                setCustomerDetails(res.data || []);
            }
        } catch (error) {
            message.showToastMessage({
                message: "Something went wrong. Try again!",
                variant: "error",
            });
        }
    };

    useEffect(() => {
        if (customerStatus) {
            getCustomerDetails();
        }
    }, [customerStatus]); // ✅ SAME AS YOUR PROJECT PARTS HOOK

    return customerDetails;
};

export default useGetCustomerDetails;
